/// <amd-module name="TFS/Views/ProjectOverviewPage/View" />
import * as React from "react";
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/Actions/ActionsHub";
import { ProjectOverviewPageActionCreator } from "TFS/Views/ProjectOverviewPage/Actions/ProjectOverviewPageActionCreator";
import { ProjectOverviewPage, ProjectOverviewPageProps } from "TFS/Views/ProjectOverviewPage/Components/ProjectOverviewPage";
import { PerformanceConstants } from "TFS/Views/ProjectOverviewPage/Constants";
import { ProjectMembersActionCreator } from "TFS/Views/ProjectOverviewPage/Shared/ProjectMembersActionCreator";
import { StoresHub } from "TFS/Views/ProjectOverviewPage/Stores/StoresHub";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";

class View extends VssComponent<IVssComponentProperties, {}> {
    private _storesHub: StoresHub;
    private _projectOverviewPageActionCreator: ProjectOverviewPageActionCreator;
    private _projectMembersActionCreator: ProjectMembersActionCreator;
    private _performanceService: IVssPerformanceService;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);

        this._performanceService = context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        this._performanceService.addSplitTiming("ProjectOverviewPageView.render.Start");

        // Initialize flux
        const actionsHub = new ActionsHub();
        this._storesHub = new StoresHub(actionsHub);
        this._projectOverviewPageActionCreator = new ProjectOverviewPageActionCreator(context.pageContext, actionsHub);

        this._projectMembersActionCreator = new ProjectMembersActionCreator(context.pageContext, actionsHub);
    }

    public componentDidMount(): void {
        super.componentDidMount();

        this._projectOverviewPageActionCreator.loadProjectOverviewData();
        this._performanceService.addSplitTiming("ProjectOverviewPageView.render.End");
    }

    public render(): JSX.Element {
        const props: ProjectOverviewPageProps = {
            storesHub: this._storesHub,
            projectOverviewActionCreator: this._projectOverviewPageActionCreator,
            projectMembersActionCreator: this._projectMembersActionCreator
        };

        return <ProjectOverviewPage {...props} />;
    }
}

VssComponent.register("TFS.ProjectOverviewPage", View);
